import * as Util from './util.js';

class Work
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Work
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //参照
    const holder = this;
    this.mask = $(".p-work__fvImg-mask");
    this.movie = this.mask.find(">a");
    this.modal = $(".p-work__movieModal");

    //SQボタンの初期化
    $(".sq-button").each(function(index){
      const div = $(this).find(">div");
      $(this).append(div.clone());
    });

    //タイトル初期化
    $(".animation-title").each(function(index){
      $(this).append("<div class='base'></div>");
      $(this).append("<div class='cover'></div>");
    });

    //キービジュアル初期化
    const img = this.mask.find("img");
    const path = img.attr("src");
    img.remove();
    let kv = $('<div class="kv"></span>');
    kv.css("background-image", "url(" + path + ")");

    //ムービーリンクがある場合
    if(this.movie.length>0)
    {
      this.movie.append(kv);
      this.movie.click(function(e){
        e.preventDefault();
        holder.open($(this).attr("href"));
      });
    }
    //ムービーリンクがない場合
    else
    {
      this.mask.append(kv);
    }

    //モーダル閉じるボタン
    this.modal.find(".p-work__movieModalCloseBtn").click((e)=>{
      e.preventDefault();
      this.close();
    });
    this.modal.on("click", function(e) {
      if ( $(e.target).closest(".p-work__movieModalWrapper").length === 0 ){
        holder.close();
      }
		});
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	スタート
	// ---------------------------------------------------------------------------------------------------------

  start(){

    //参照
    const info = $(".p-work__fvInfo");
    const title = info.find(".title");
    const subtitle = info.find(".subtitle");
    const jp = info.find(".jp");
    const en = info.find(".en");

    //画像スライドイン
    const fader = $(".p-work__fvImg-fader");
    TweenMax.to(fader, 0.8, {width:"0%", delay:0.8, ease:Quint.easeInOut});

    //画像拡大から縮小
    const kv = $(".p-work__fvImg .kv");
    TweenMax.set(kv, {scaleX:1.2, scaleY:1.2});
    TweenMax.to(kv, 1.2, {scaleX:1.0, scaleY:1.0, delay:0.8, ease:Power1.easeOut});

    title.addClass("enter");
    TweenMax.delayedCall(0.6, ()=>{
      title.addClass("show");
    });

    TweenMax.delayedCall(0.1, ()=>{
      subtitle.addClass("enter");
    });
    TweenMax.delayedCall(0.7, ()=>{
      subtitle.addClass("show");
    });

    TweenMax.delayedCall(0.3, ()=>{
      jp.addClass("enter");
    });
    TweenMax.delayedCall(0.9, ()=>{
      jp.addClass("show");
    });

    TweenMax.delayedCall(0.4, ()=>{
      en.addClass("enter");
    });
    TweenMax.delayedCall(1.0, ()=>{
      en.addClass("show");
    });

    $(".p-work__fvInfo-ui >li").each(function(index){

      const li = $(this);

      TweenMax.delayedCall(0.5, ()=>{
        li.addClass("enter");
      });
      TweenMax.delayedCall(1.1, ()=>{
        li.addClass("show");
      });

    });
  }




  // ---------------------------------------------------------------------------------------------------------
	// --	動画モーダル関連
	// ---------------------------------------------------------------------------------------------------------

  open(href){

    //参照
    const wrapper = this.modal.find(".p-work__movieModalWrapper");
    const container = this.modal.find(".iframe-container");
    const fader = this.modal.find(".fader");
    const closeBtn = this.modal.find(".p-work__movieModalCloseBtn");

    //ムービー配置
    container.empty();
    container.append('<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="'+href+'?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>');
    TweenMax.set(container, {alpha:0});

    //Tween
    TweenMax.killTweensOf(this.modal);
    TweenMax.set(this.modal, {alpha:0});
    TweenMax.to(this.modal, 0.1, {alpha:1, ease:Power0.easeNone});
    this.modal.css("display", "flex");

    TweenMax.killTweensOf(wrapper);
    TweenMax.set(wrapper, {alpha:0, scaleX:0.95, scaleY:0.95});
    TweenMax.to(wrapper, 0.6, {alpha:1, scaleX:1.0, scaleY:1.0, delay:0.1, ease:Back.easeOut.config(1.7), onComplete:()=>{
    }});

    TweenMax.killTweensOf(closeBtn);
    TweenMax.set(closeBtn, {alpha:0});
    TweenMax.to(closeBtn, 0.6, {alpha:1, ease:Power0.easeNone, delay:0.6});

    //フェーダー
    TweenMax.set(fader, {alpha:1});
    TweenMax.to(fader, 0.6, {alpha:0, ease:Power0.easeNone, delay:0.6, onStart:()=>{
      TweenMax.set(container, {alpha:1});
    }});
  }

  close(){

    const container = this.modal.find(".iframe-container");
    container.empty();

    TweenMax.killTweensOf(this.modal);
    TweenMax.to(this.modal, 0.0, {alpha:0, ease:Power0.easeNone, onComplete:()=>{
      this.modal.css("display", "none");
    }});
  }


  // ---------------------------------------------------------------------------------------------------------
}

export default Work;
